import { Component, Input, OnInit } from '@angular/core';
import { FlexEdTransaction } from '@app/flex-ed/services/flex-ed.service';

@Component({
  selector: 'dgx-flex-ed-transactions',
  templateUrl: './flex-ed-transactions.component.html',
})
export class FlexEdTransactionsComponent {
  @Input() public transactionHistory: FlexEdTransaction[];
}
